<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="Property" name="first">
                <Property></Property>
            </el-tab-pane>

            <el-tab-pane label="Doors" name="doors" lazy>
                <Door></Door>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Property from "@/view/property/Property";
    import Door from "@/view/eazable/Door";

    export default {
        name: "PropertyIndex",
        components: {Door, Property},
        data() {
            return {activeName: 'first'};
        }
    }
</script>

<style scoped>

</style>
